import React from 'react';
import NavTop from '../../components/NavTop';
import NavRoot from '../../components/NavRoot';
import FooterButtons from '../../components/FooterButtons';
import InputText from '../../components/InputText';
import TeamSelector from '../team/Selector';

const EditTable = ({ local, onChange, onSave, onDelete, onRefresh, disable, hasChanged }) => {
  return (
    <div className="container">
      <NavTop />
      <NavRoot page="locations" />
      <div className="col-sm-8">
        <form>
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="huge">Name</th>
                <th className="xlarge">Team</th>
                <th className="massive">URL String</th>
                <th className="medium center">Check URL</th>
                <th className="medium">Delete</th>
              </tr>
            </thead>
            <tbody>
              {local.map((entry) =>
                <tr key={entry.id}>
                  <td className="huge">
                    <InputText
                      type="text"
                      name="name"
                      disabled={disable}
                      entry={entry}
                      handleChange={(e) => onChange({ event: e, id: entry.id })} />
                  </td>
                  <td className="xlarge">
                    <TeamSelector
                      id={entry.id}
                      name="teamID"
                      value={Number(entry.teamID)}
                      deleted={entry.deleted}
                      disabled={disable}
                      onChange={onChange}
                    />
                  </td>
                  <td className="massive">
                    <InputText
                      type="text"
                      name="url"
                      disabled={disable}
                      entry={entry}
                      handleChange={(e) => onChange({ event: e, id: entry.id })} />
                  </td>
                  <td className="medium center">
                    {entry.url ? <a
                      href={entry.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Check
                    </a> : null}
                  </td>
                  <td className="medium">
                    <button
                      type="button"
                      className="btn btn-danger"
                      name="delete"
                      disabled={disable || entry.empty || entry.cannot_delete}
                      onClick={() => onDelete(entry.id)}>
                      {entry.deleted ? 'Undo' : 'Delete'}
                    </button>
                  </td>
                </tr>,
              )}
            </tbody>
          </table>
          <FooterButtons
            hasChanged={hasChanged}
            disabled={disable}
            onSave={onSave}
            onRefresh={onRefresh}
          />
        </form>
      </div>
    </div>
  );
};

export default EditTable;
